import { useEffect, useRef } from "react";
import { Marker, useMap } from "react-leaflet";
import { maxZoomLgvIconTuneValue } from "../../util/helper/constants";

function LgvMarker({ index, lgvMarker, icon, groupOffset, isMaxZoom, onClick }) {
  const markerRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    return () => {
      // Manual cleanup to avoid duplication
      if (markerRef.current && map) {
        map.removeLayer(markerRef.current);
      }
    };
  }, [index, map]);

  const getCorrectedPosition = () => {
    if(isMaxZoom) {
      return [
        lgvMarker.currentPos.lat + groupOffset.x + maxZoomLgvIconTuneValue[0],
        lgvMarker.currentPos.lng + groupOffset.y + maxZoomLgvIconTuneValue[1],
      ]
    } else {
      return [
        lgvMarker.currentPos.lat + groupOffset.x,
        lgvMarker.currentPos.lng + groupOffset.y,
      ]
    }
  }

  return (
    <Marker
      ref={markerRef}
      type="lgv"
      key={lgvMarker.vehicleNumber}
      data={lgvMarker}
      position={getCorrectedPosition()}
      icon={icon}
      eventHandlers={{
        click: onClick,
      }}
    />
  );
}

export default LgvMarker;
